import type { ComponentPropsOptions, ExtractPublicPropTypes } from "vue";
import type { FlexComponent } from "@/utils/render-component";
import { defineComponent } from "vue";
import HoverCard from "@/components/primitives/hover/HoverCard";
import { p } from "@/utils/props-builder";
import { renderComponent } from "@/utils/render-component";
import Icon from "../icon/Icon";

const props = {
  side: p.string<"top" | "right" | "bottom" | "left">(),
  align: p.string<"start" | "center" | "end">(),
  delay: p.number(),
  width: p.number(),
  orientation: p.string<"horizontal" | "vertical">("horizontal"),
  content: p.custom<FlexComponent>([String, Object]),
} satisfies ComponentPropsOptions;

export type InfoProps = ExtractPublicPropTypes<typeof props>;

export default defineComponent({
  name: "Info",
  props,
  setup(props) {
    return () => (
      <HoverCard.Root openDelay={props.delay ?? 100}>
        <HoverCard.Trigger>
          <Icon
            icon="lucide:info"
            class="mb-1 ml-1.5 h-3.5 w-3.5 cursor-help opacity-50 transition hover:opacity-100"
          />
        </HoverCard.Trigger>
        <HoverCard.Content
          side={props.side}
          align={props.align ?? "start"}
          class={[props.orientation === "horizontal" ? "px-2.5 py-1.5" : "px-2 py-3"]}
          style={{
            width: props.width ? `${props.width}px` : "20rem",
          }}
        >
          {typeof props.content === "string" ? (
            <p class="leading-relaxed">{props.content}</p>
          ) : (
            renderComponent(props.content as FlexComponent)
          )}
        </HoverCard.Content>
      </HoverCard.Root>
    );
  },
});
